// Journal d'audit — toutes les actions admin (grant, revoke, broadcast, ...).
// Paginé, filtre optionnel par user cible.
import React, { useEffect, useState } from "react";
import { adminAuditLog } from "../services/authService";

function formatDateTime(v) {
	if (!v) return "—";
	const d = new Date(v);
	if (isNaN(d)) return "—";
	return d.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
}

const ACTION_LABELS = {
	grant_license: { label: "Attribution licence", color: "#a78bfa" },
	revoke_license: { label: "Révocation licence", color: "#e57373" },
	broadcast: { label: "Broadcast push", color: "#30a49a" },
};

export default function AdminAuditLogPanel() {
	const [actions, setActions] = useState([]);
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [total, setTotal] = useState(0);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const load = async (p) => {
		setLoading(true);
		const result = await adminAuditLog({ page: p });
		setLoading(false);
		if (result.success) {
			setActions(result.actions || []);
			setTotalPages(result.totalPages || 1);
			setTotal(result.total || 0);
		} else {
			setError(result.error || "Erreur");
		}
	};

	useEffect(() => { load(page); }, [page]);

	return (
		<div>
			<div className="admin-users-toolbar" style={{ marginBottom: 12 }}>
				<span style={{ color: "var(--ink-soft)", fontSize: 14 }}>
					{total} action{total > 1 ? "s" : ""} enregistrée{total > 1 ? "s" : ""}
				</span>
				<button className="mens-btn ghost small" onClick={() => load(page)}>Rafraîchir</button>
			</div>

			{error && <div className="admin-error">{error}</div>}
			{loading && <div className="admin-loading">Chargement...</div>}

			{!loading && actions.length === 0 && (
				<div className="admin-empty">Aucune action enregistrée.</div>
			)}

			{!loading && actions.length > 0 && (
				<div className="admin-users-table-wrap">
					<table className="admin-users-table">
						<thead>
							<tr>
								<th>Date</th>
								<th>Admin</th>
								<th>Action</th>
								<th>Cible</th>
								<th>Détails</th>
							</tr>
						</thead>
						<tbody>
							{actions.map((a) => {
								const meta = ACTION_LABELS[a.actionType] || { label: a.actionType, color: "var(--ink-soft)" };
								return (
									<tr key={a.id}>
										<td style={{ whiteSpace: "nowrap" }}>{formatDateTime(a.logDate)}</td>
										<td>
											<div className="admin-user-name">{a.adminName?.trim() || "—"}</div>
											<div className="admin-user-email">{a.adminEmail}</div>
										</td>
										<td>
											<span className="admin-tier-badge" style={{ color: meta.color, borderColor: meta.color + "80" }}>
												{meta.label}
											</span>
										</td>
										<td>
											{a.targetUserId ? (
												<>
													<div className="admin-user-name">{a.targetName?.trim() || "—"}</div>
													<div className="admin-user-email">{a.targetEmail}</div>
												</>
											) : <span style={{ color: "var(--ink-soft)" }}>—</span>}
										</td>
										<td style={{ fontSize: "0.82rem", color: "var(--ink-soft)" }}>
											{a.details || "—"}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<div className="admin-users-pagination">
						<span>Page {page} / {totalPages}</span>
						<div>
							<button className="mens-btn ghost small" disabled={page <= 1} onClick={() => setPage(page - 1)}>← Précédent</button>
							<button className="mens-btn ghost small" disabled={page >= totalPages} onClick={() => setPage(page + 1)} style={{ marginLeft: 6 }}>Suivant →</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
